import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

interface TestResultsCardProps {
  onClick: () => void;
}

export default function TestResultsCard({ onClick }: TestResultsCardProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const getCardTitleText = () => {
    return (
      t("screening.test_results_card_title_nj") ??
      `Docket now supports certain test results recorded.`
    );
  };

  const getCardBodyText = () => {
    return t("screening.test_results_card_body_nj") ?? "Access your results.";
  };

  return (
    <>
      <div className="flex bg-base-100 mx-4 py-1 mb-2 w-fit text-base-content items-center  rounded-xl">
        <img className="w-10 mx-2" src="/assets/images/Tests_Generic.png" alt="Lead Result Tests" />
        <div data-testid="lead-disclaimer-card">
          <span>{getCardTitleText()}</span>
          <button onClick={onClick} className="btn btn-link text-primary pl-1 text-base my-0 h-fit">
            {getCardBodyText()}
          </button>
        </div>
      </div>
    </>
  );
}
